import { ReactElement } from 'react';
import { Stack, Text } from '@mantine/core';
import { joinClassNames } from 'utils/joinClassNames';
import styles from './NavSection.module.css';

export type NavSectionProps = {
    label?: string;
    children: ReactElement | ReactElement[];
    className?: string;
    expanded?: boolean;
};

export function NavSection({ label, children, className, expanded }: NavSectionProps) {
    return (
        <Stack gap="xs" className={joinClassNames(styles.navSection, className)}>
            {label && (
                <Text className={joinClassNames(styles.label, expanded ? styles.labelCollapsed : '')}>
                    {expanded ? label : '-'}
                </Text>
            )}
            {children}
        </Stack>
    );
}
